import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ChangeDetectorRef, Component, effect, inject, input, Input, signal, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { SearchStore } from '../../../store/search.store';
import { ILocalidades } from '../../models/ILocalidades';
import { UrlService } from '../../services/ecommerce/generar-url-amigable.service';
import { GetLocalidadesService } from '../../services/ecommerce/getLocalidades.service';
import { LocalStorageService } from '../../services/ecommerce/localstorage.service';
import { PassengerSelectorComponent } from '../PassengerSelector/PassengerSelector.component';
import moment from 'moment';
import 'moment/locale/es';
import { HelpersService } from '../../services/ecommerce/helpers.service';
import { DatePickerModule } from 'primeng/datepicker';
import { FluidModule } from 'primeng/fluid';
import { IftaLabelModule } from 'primeng/iftalabel';
import { Select } from 'primeng/select';
import { ComprarService } from '../../services/bottonComprar.service';
import { EcommerceService } from '../../services/ecommerce-state.service';

@Component({
	selector: 'app-formulario-buscador',
	standalone: true,
	imports: [
		CommonModule,
		PassengerSelectorComponent,
		HttpClientModule,
		FormsModule,
		ReactiveFormsModule,
		FluidModule,
		DatePickerModule,
		IftaLabelModule,
		Select
	],
	providers: [SearchStore],
	templateUrl: './formulario-buscador.component.html',
	styleUrl: './formulario-buscador.component.css'
})
export class FormularioBuscadorComponent {
	codigoEcommerceIda: number = 72;
	@Input() codigoEcommerceVuelta: number = 0;
	// codigoEcommerceVuelta = input<string | null>(null);
	origen: number | undefined;
	destino: number | undefined;
	fechaSalida: Date | undefined;
	fechaRegreso: Date | undefined;
	minFechaRetorno = signal<Date | undefined>(undefined);
	searchStore = inject(SearchStore);
	private _locadidades = inject(GetLocalidadesService);
	private cdr = inject(ChangeDetectorRef);
	private fb = inject(FormBuilder);
	private router = inject(Router);
	private _generarUrl = inject(UrlService);
	private localStorageService = inject(LocalStorageService);
	private serviceHelpers = inject(HelpersService);
	filtroForm!: FormGroup;
	formSubmitted = false;
	today: Date | undefined; // Fecha actual en formato 'yyyy-mm-dd'

	products$!: Observable<ILocalidades[]>;
	localidadesOrigen: ILocalidades[] = [];
	localidadesDestino: ILocalidades[] = [];
	localidadesDestinoLoading = false;
	Seleccionar: string = 'Seleccionar';
	textoSeleccionadoOrigen: string | undefined;
	textoSeleccionadoDestino: string | undefined;
	idOrigen = signal(0);
	idDestino = signal(0);
	indicador = signal(0);
	jdjdj: any = '';
	public ecommerce = inject(EcommerceService);

	private sub2: Subscription;

	codigoEcommerceVuelta2: number = 0;

	@Input() _idDestinoDesdeDetalleDestino: number = 0;

	searchState$ = SearchStore;
	constructor(private comprarService: ComprarService) {
		this.sub2 = this.ecommerce.open$.subscribe((data) => {
			if (data) {
				this.codigoEcommerceVuelta2 = data!;
			} else {
				this.codigoEcommerceVuelta2 = 0;
			}
			this.obtenerLocalidadDestino(this.codigoEcommerceIda);

			// this.codigoSig = data!;
		});
		// effect(
		// 	() => {
		// 		const dataDesdeBoton = this.comprarService.compraInfo();
		// 		this.codigoEcommerceVuelta = dataDesdeBoton;
		// 	},
		// 	{ allowSignalWrites: true }
		// );
		moment.locale('es'); // Establecer el idioma a español
	}
	ngOnDestroy() {
		this.sub2.unsubscribe();
		this.codigoEcommerceVuelta2 = 0;
		// this.sub2.unsubscribe();
	}
	// ngOnChanges(changes: SimpleChanges) {
	// 	if (changes['codigoEcommerceVuelta']?.currentValue) {
	// 		this.setDestinoPorDefecto();
	// 	}
	// }
	// setDestinoPorDefecto() {
	// 	// const control = this.filtroForm.get('destino');
	// 	// if (!control) return;

	// 	if (!this.filtroForm) return;

	// 	// si aun no hay input o no hay opciones, no hacemos nada
	// 	if (!this.codigoEcommerceVuelta) return;

	// 	// Como usamos optionValue="codigoEcommerce", basta con poner el número
	// 	this.filtroForm.get('destino')?.setValue({
	// 		id: 13,
	// 		denominacion: 'BARRANCA'
	// 	});
	// }
	ngAfterViewInit() {}
	ngOnInit() {
		const today = new Date();
		this.today = today;
		this.generarFormulario();
		this._locadidades.getLocalidadesOrigen().subscribe((data) => {
			const destinos_ = data;
			const ordenado = destinos_.sort((a, b) => {
				if (a.denominacion === 'LIMA') return -1;
				if (b.denominacion === 'LIMA') return 1;
				return 0;
			});
			this.localidadesOrigen = ordenado;
			const valorPorDefectoIda = this.localidadesOrigen.find((localidad) => localidad.id === this.codigoEcommerceIda);
			const valorPorDefectoVuelta = this.localidadesOrigen.find(
				(localidad) => localidad.id === Number(this.codigoEcommerceVuelta)
			);
			this.filtroForm.get('origen')?.setValue(valorPorDefectoIda);

			// if (valorPorDefectoVuelta?.denominacion) {
			// 	this.filtroForm.get('destino')?.setValue(valorPorDefectoVuelta);
			// 	this.jdjdj = valorPorDefectoVuelta;
			// 	console.log(this.codigoEcommerceVuelta, valorPorDefectoVuelta, 'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa');
			// }
		});
	}
	onSelectLocalidad(origenId: any) {
		this.filtroForm.get('destino')?.setValue(null);
		this.filtroForm.get('fechaSalida')?.setValue(null);
		this.filtroForm.get('fechaRetorno')?.setValue(null);
		this.idOrigen.set(origenId.value.id);
		this.obtenerLocalidadDestino(origenId.value.id);
		this.textoSeleccionadoOrigen = origenId;
	}
	onSelectDestino(origenId: any) {
		this.textoSeleccionadoDestino = origenId.value.denominacion;
		this.idDestino.set(origenId.value.id);
		this.filtroForm.get('fechaSalida')?.setValue(null);
		this.filtroForm.get('fechaRetorno')?.setValue(null);
		const indicador = this.serviceHelpers.indicadorRuta24Horas(
			this.filtroForm.get('origen')?.value.id,
			origenId.value.id
		);
		this.indicador.set(indicador);
	}
	onSelectFechaIda(fecha: any) {
		if (fecha) {
			this.filtroForm.get('fechaRetorno')?.setValue(null);
			const nuevaFechaMinima = new Date(fecha); // Copiar la fecha seleccionada
			nuevaFechaMinima.setDate(nuevaFechaMinima.getDate() + 1); // Aumentar un día
			this.minFechaRetorno.set(fecha);
			this.filtroForm.get('fechaRetorno')?.setValue(null);
			if (this.indicador() === 0) {
				this.minFechaRetorno.set(nuevaFechaMinima);
				this.cdr.detectChanges();
			}
		}
	}
	obtenerLocalidadDestino(idOrigen: number) {
		this.localidadesDestinoLoading = true;
		this.localidadesDestino = [];
		this._locadidades.getLocalidadesDestino(idOrigen).subscribe(
			(data) => {
				this.localidadesDestino = data;
				this.localidadesDestinoLoading = false;
				const valorPorDefectoVuelta = this.localidadesDestino.find(
					(localidad) => localidad.id === Number(this.codigoEcommerceVuelta2)
				);

				if (valorPorDefectoVuelta) {
					this.filtroForm.get('destino')?.setValue(valorPorDefectoVuelta);
				} else {
					this.filtroForm.get('destino')?.setValue(null);
				}
			},
			(error) => {}
		);
	}
	generarFormulario() {
		this.filtroForm = this.fb.group({
			fechaSalida: ['', Validators.required],
			fechaRetorno: ['', Validators.required],
			// origen: [null, Validators.required],
			origen: [null, Validators.required],
			destino: [null, Validators.required],
			adultos: this.fb.control(1),
			ninios: this.fb.control(0),
			bebes: this.fb.control(0),
			quieroAsiento: this.fb.control(false)
		});
		// Escuchar cambios en `fechaSalida` y actualizar `minFechaRetorno`
		// this.filtroForm.get('fechaSalida')?.valueChanges.subscribe((fechaSalida) => {
		// 	this.minFechaRetorno.set(fechaSalida || '');
		// 	this.filtroForm.get('fechaRetorno')?.patchValue('');
		// 	this.cdr.detectChanges();
		// });
	}
	onPassengersChange(passengers: { adults: number; children: number; infants: number; quieroAsiento: boolean }) {
		this.filtroForm.get('adultos')?.patchValue(passengers.adults);
		this.filtroForm.get('ninios')?.patchValue(passengers.children);
		this.filtroForm.get('bebes')?.patchValue(passengers.infants);
		this.filtroForm.get('quieroAsiento')?.patchValue(passengers.quieroAsiento);
	}
	obtenerParametros() {
		const formValues = this.filtroForm.value;
		return {
			queryParams: {
				tipoProceso: 'Ida',
				iditinerario: '',
				idruta: '',
				origen: formValues.origen,
				destino: formValues.destino,
				fechaSalida: formValues.fechaSalida,
				fechaRetorno: formValues.fechaRetorno,
				adultos: formValues.adultos,
				ninios: formValues.ninios,
				bebes: formValues.bebes,
				quieroAsiento: formValues.quieroAsiento
			}
		};
	}
	onSubmit() {
		const formValues = this.filtroForm.value;
		const today = moment().format('YYYY-MM-DD');
		// const totalPasajeros = formValues.adultos + formValues.ninios + formValues.bebes;
		let fechaDeSalida = moment(formValues.fechaSalida).format('YYYY-MM-DD');
		let fechaDeRetorno = moment(formValues.fechaRetorno).format('YYYY-MM-DD');

		let full = 0;
		if (!formValues.origen) {
			alert('Tienes que elegir un origen.');
			return;
		}
		if (!formValues.destino) {
			alert('Tienes que elegir un destino.');
			return;
		}
		// if (totalPasajeros < 1) {
		// 	alert('Debes seleccionar al menos un tipo de pasajero.');
		// 	return;
		// }
		// if (formValues.adultos == 0 && formValues.bebes > 0) {
		// 	alert('Los Bebés deben viajar acompañado por un adulto.');
		// 	return;
		// }
		if (formValues.fechaSalida && formValues.fechaRetorno) {
			full = 1;
		}
		if (!formValues.fechaSalida) {
			fechaDeSalida = today;
		}
		if (!formValues.fechaRetorno) {
			fechaDeRetorno = '';
		}
		const slug = this._generarUrl.generarRutaUrl(
			this.filtroForm.get('origen')?.value.denominacion,
			this.filtroForm.get('destino')?.value.denominacion
		);
		const busqueda_ = {
			id_origen: formValues.origen.id,
			id_destino: formValues.destino.id,
			nombre_ciudadOrigen: this.filtroForm.get('origen')?.value.denominacion,
			nombre_ciudadDestino: this.filtroForm.get('destino')?.value.denominacion,
			fecha_ida: fechaDeSalida,
			fecha_regreso: fechaDeRetorno,
			num_adultos: formValues.adultos,
			num_ninos: formValues.ninios,
			num_bebes: formValues.bebes,
			quiero_asiento: formValues.quieroAsiento,
			url_amigable: slug,
			busqueda_full: full,
			indicador: this.indicador()
		};
		const busqueda = [
			{
				id_origen: formValues.origen.id,
				id_destino: formValues.destino.id,
				nombre_ciudadOrigen: this.filtroForm.get('origen')?.value.denominacion,
				nombre_ciudadDestino: this.filtroForm.get('destino')?.value.denominacion,
				fecha_ida: fechaDeSalida,
				fecha_regreso: fechaDeRetorno,
				num_adultos: formValues.adultos,
				num_ninos: formValues.ninios,
				num_bebes: formValues.bebes,
				quiero_asiento: formValues.quieroAsiento,
				url_amigable: slug,
				busqueda_full: full,
				indicador: this.indicador()
			}
		];
		this.localStorageService.setArray('busqueda', busqueda);
		this.searchStore.updateAllFields(busqueda_);
		this.router.navigate(['/pasajes-en-bus/paso1/', slug, fechaDeSalida, 'ida']);
	}
}
